<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-22 13:01:29
 * @LastEditTime: 2019-10-16 12:38:12
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div ref="wrapper" class="scroll-wrapper">
    <slot></slot>
  </div>
</template>

<script>
import BScroll from "better-scroll";
import comTools from "../../../assets/js/until";
export default {
  name: "Scroll",
  data() {
    return {};
  },
  props: {
    // probeType(监听当前位置)
    probeType: {
      type: Number,
      // default: 默认
      default: 1
    },
    // click: 是否可点击
    click: {
      type: Boolean,
      default: true
    },
    // pullUpLoad: 是否上拉加载功能
    pullUpLoad: {
      type: Boolean,
      default: false
    },
    // pullDownRefresh: 是否下拉刷新功能
    pullDownRefresh: {
      type: Boolean,
      default: false
    },
    // mouseWheel: 是否开启滚动条
    mouseWheel: {
      type: Boolean,
      default: true
    },
    // scrollX: 是否横向滚动
    scrollX: {
      type: Boolean,
      default: false
    },
    // scrollY: 是否纵向滚动
    scrollY: {
      type: Boolean,
      default: true
    },
    // refreshDelay: 刷新延迟时间(单位: ms)
    refreshDelay: {
      type: Number,
      default: 20
    },
    data: {
      type: Array,
      default() {
        return [];
      }
    }
  },

  // mounted: 生命周期的结束
  mounted() {
    // console.log("this.pullUpLoad", this.pullUpLoad);

    setTimeout(this._initScroll, 50);
  },
  methods: {
    // 初始化滚动插件
    _initScroll() {
      if (!this.$refs.wrapper) {
        return;
      }
      // 1.创建 BetterScroll
      this.scroll = new BScroll(this.$refs.wrapper, {
        // 是否横向滚动
        scrollX: this.scrollX,
        // 是否纵行滚动
        scrollY: this.scrollY,
        // 实时的监听当前位置
        probeType: this.probeType,
        // 是否可点击
        click: this.click,
        // 是否可上拉加载
        pullUpLoad: this.pullUpLoad,
        // 是否可下拉刷新
        pullDownRefresh: this.pullDownRefresh,
        // 是否开启滚动条
        mouseWheel: this.mouseWheel,
      });

      // 2.事件滚动
      if (this.probeType === 2 || this.probeType === 3) {
        // 常规处理
        // this.scroll.on("scroll", position => {
        //   // console.log("this.pullUpLoad", this.pullUpLoad);
        //   this.$emit("scroll", position);
        // });
        // 节流处理
        this.scroll.on(
          "scroll",
          comTools.setDebounce(position => {
            // console.log(position);

            this.$emit("scroll", position);
          })
        );
      }

      // 3.上拉加载
      if (this.pullUpLoad) {
        this.scroll.on("pullingUp", () => {
          this.$emit("pullingUp");
          // console.log("this.pullUpLoad", this.pullUpLoad);
        });
      }

      // 4.下拉刷新
      if (this.pullDownRefresh) {
        this.scroll.on("pullDownRefresh", () => {
          console.log("下拉刷新");
        });
      }
    },
    /**
     * disable: 禁用 better-scroll
     */
    disable() {
      this.scroll && this.scroll.disable();
    },
    /**
     * enable: 启用 better-scroll
     */
    enable() {
      this.scroll && this.scroll.enable();
    },
    /**
     * refresh: 刷新better-scolll, 重新计算 better-scroll 结构
     */
    refresh() {
      this.scroll && this.scroll.refresh();
    },

    /**
     * scrollTo: 滚动到指定的目标元素
     *  [Number]: x坐标
     *  [Number]: y坐标
     *  [Number]: time(时间)
     */
    scrollTo(x, y, time = 100) {
      this.scroll && this.scroll.scrollTo && this.scroll.scrollTo(x, y, time);
    },

    /**
     * scrollToElement: 滚动到指定的目标元素
     *   [DOM|String]:      目标位置
     *   [Number]:          time(时间)
     *   [Number|Boolean]:  offsetX(横轴偏移量,如果设置 true 偏移目标的一半)
     *   [Number|Boolean]:  offsetY(纵轴偏移量,如果设置 true 偏移目标的一半)
     */
    scrollToElement(el, time, offsetX, offsetY) {
      this.scroll &&
        this.scroll.scrollToElement &&
        this.scroll.scrollToElement(el, time, offsetX, offsetY);
    },

    /**
     * finishPullUp: 可以让上拉加载执行多次
     */
    finishPullUp() {
      this.scroll && this.scroll.finishPullUp && this.scroll.finishPullUp();
    },

    /**
     * finishPullDown: 可以让下拉刷新执行多次
     */
    finishPullDown() {
      this.scroll && this.scroll.finishPullDown && this.scroll.finishPullDown();
    }
  },
  watch: {
    /**
     * 当数据发送改变刷新 better-scroll
     */
    data() {
      setTimeout(this.refresh, this.refreshDelay);
    },
    pullUpLoad(val, oldVal) {
      // console.log("pullUpLoad", val, oldVal);
      deep: true;
    }
  }
};
</script>

<style lang="less" scoped>
// .wrapper {
//   overflow: hidden;
// }
</style>

